import type { ResetStore } from "@yjsgames/daily-reset";

/**
 * @yjsgames/daily-reset `ResetStore` Port의 프로젝트 어댑터 (DIP).
 * 마지막 리셋 시각을 `SaveData.dailyResets` 맵에 위임 저장한다 — idleblade `ResetTimerSaveEntry` 역할.
 *
 * 맵을 직접 받지 않고 접근자(`read`)로 받아, GameScene이 로드 시 `dailyResets`를 reassign해도
 * stale 참조가 되지 않게 한다 (항상 현재 맵을 읽고 in-place 변경 → persist가 그대로 직렬화).
 */
export class SaveDataResetStore implements ResetStore {
  constructor(private readonly read: () => Record<string, number>) {}

  getLastReset(key: string): number | undefined {
    // Record 인덱싱은 noUncheckedIndexedAccess 비활성 환경에서 number로 추론되나 런타임 undefined 가능 → 계약대로 명시.
    return this.read()[key] as number | undefined;
  }

  setLastReset(key: string, ms: number): void {
    this.read()[key] = ms;
  }
}
